<template>
  <div class="supervisao-page">
    <div class="page-header">
      <div>
        <h1>Inspeção de Integração ao SISBI-POA</h1>
        <p>Componente conceito para POC - Laudo de Supervisão</p>
      </div>

      <div class="header-actions">
        <button class="btn-outline" @click="abaAtiva = 'cabecalho'">Cabeçalho</button>
        <button class="btn-outline" @click="abaAtiva = 'avaliacao'">Avaliação</button>
        <button class="btn-outline" @click="abaAtiva = 'fechamento'">Fechamento</button>
        <button class="btn-primary" @click="gerarRelatorio">Gerar Relatório Base</button>
      </div>
    </div>

    <div class="status-bar">
      <div class="status-card">
        <span class="status-label">Modelo</span>
        <strong>{{ modelo.descricao }}</strong>
      </div>
      <div class="status-card">
        <span class="status-label">Itens Utilizáveis</span>
        <strong>{{ resumo.totalUtilizaveis }}</strong>
      </div>
      <div class="status-card">
        <span class="status-label">Conformes</span>
        <strong>{{ resumo.totalC }}</strong>
      </div>
      <div class="status-card">
        <span class="status-label">% Conformidade</span>
        <strong>{{ resumo.percentualFormatado }}</strong>
      </div>
      <div class="status-card">
        <span class="status-label">Classificação</span>
        <strong>{{ resumo.grupoClassificacao }}</strong>
      </div>
    </div>

    <!-- CABEÇALHO -->
    <section v-if="abaAtiva === 'cabecalho'" class="card-section">
      <h2>Dados do Laudo</h2>

      <div class="form-grid">
        <div class="form-item col-2">
          <label>Número do Laudo</label>
          <input v-model="laudo.numeroLaudo" type="text" />
        </div>

        <div class="form-item">
          <label>Data da Inspeção</label>
          <input v-model="laudo.dataInspecao" type="date" />
        </div>

        <div class="form-item">
          <label>Tipo de Supervisão</label>
          <select v-model="laudo.tipoSupervisao">
            <option value="SUPERVISAO ANUAL">SUPERVISÃO ANUAL</option>
            <option value="OUTROS">OUTROS</option>
          </select>
        </div>

        <div v-if="laudo.tipoSupervisao === 'OUTROS'" class="form-item col-2">
          <label>Descrição - Outros</label>
          <input v-model="laudo.tipoSupervisaoOutros" type="text" />
        </div>
      </div>

      <h3>Identificação do Estabelecimento</h3>
      <div class="form-grid">
        <div class="form-item col-2">
          <label>Razão Social</label>
          <input v-model="laudo.razaoSocial" type="text" />
        </div>

        <div class="form-item col-2">
          <label>Nome Fantasia</label>
          <input v-model="laudo.nomeFantasia" type="text" />
        </div>

        <div class="form-item">
          <label>Número de Registro no SIM-POA</label>
          <input v-model="laudo.numeroRegistroSim" type="text" />
        </div>

        <div class="form-item">
          <label>Inscrição Estadual</label>
          <input v-model="laudo.inscricaoEstadual" type="text" />
        </div>

        <div class="form-item">
          <label>CNPJ/CPF</label>
          <input v-model="laudo.cnpjCpf" type="text" />
        </div>

        <div class="form-item col-2">
          <label>Endereço</label>
          <input v-model="laudo.endereco" type="text" />
        </div>

        <div class="form-item">
          <label>Bairro</label>
          <input v-model="laudo.bairro" type="text" />
        </div>

        <div class="form-item">
          <label>Município</label>
          <input v-model="laudo.municipio" type="text" />
        </div>

        <div class="form-item">
          <label>CEP</label>
          <input v-model="laudo.cep" type="text" />
        </div>

        <div class="form-item">
          <label>UF</label>
          <input v-model="laudo.uf" type="text" maxlength="2" />
        </div>

        <div class="form-item">
          <label>Telefone</label>
          <input v-model="laudo.telefone" type="text" />
        </div>

        <div class="form-item">
          <label>E-mail</label>
          <input v-model="laudo.email" type="text" />
        </div>

        <div class="form-item col-2">
          <label>Atividade</label>
          <input v-model="laudo.atividade" type="text" />
        </div>

        <div class="form-item col-2">
          <label>Classificação do Estabelecimento</label>
          <input v-model="laudo.classificacaoEstabelecimento" type="text" />
        </div>
      </div>

      <h3>Dados do Estabelecimento / Responsável Técnico</h3>
      <div class="form-grid">
        <div class="form-item">
          <label>Possui Responsável Técnico?</label>
          <select v-model="laudo.possuiResponsavelTecnico">
            <option value="N">NÃO</option>
            <option value="S">SIM</option>
          </select>
        </div>

        <div class="form-item col-2">
          <label>Nome do Responsável Técnico</label>
          <input v-model="laudo.nomeResponsavelTecnico" type="text" />
        </div>

        <div class="form-item">
          <label>Formação Acadêmica</label>
          <input v-model="laudo.formacaoAcademica" type="text" />
        </div>

        <div class="form-item">
          <label>Nº Pessoas na Atividade</label>
          <input v-model.number="laudo.numeroPessoas" type="number" min="0" />
        </div>

        <div class="form-item">
          <label>Nº Turnos</label>
          <input v-model.number="laudo.numeroTurnos" type="number" min="0" />
        </div>
      </div>

      <h3>Responsável por Acompanhar a Inspeção</h3>
      <div class="form-grid">
        <div class="form-item col-2">
          <label>Nome Completo</label>
          <input v-model="laudo.nomeAcompanhante" type="text" />
        </div>

        <div class="form-item">
          <label>CPF</label>
          <input v-model="laudo.cpfAcompanhante" type="text" />
        </div>

        <div class="form-item">
          <label>Função</label>
          <input v-model="laudo.funcaoAcompanhante" type="text" />
        </div>
      </div>

      <h3>Dados da Supervisão</h3>
      <div class="form-grid">
        <div class="form-item col-2">
          <label>Fiscal Responsável pelo Estabelecimento</label>
          <input v-model="laudo.fiscalEstabelecimento" type="text" />
        </div>

        <div class="form-item col-2">
          <label>Fiscal Responsável pela Supervisão</label>
          <input v-model="laudo.fiscalSupervisao" type="text" />
        </div>

        <div class="form-item">
          <label>Data/Hora de Início</label>
          <input v-model="laudo.dataInicio" type="datetime-local" />
        </div>

        <div class="form-item">
          <label>Data/Hora de Finalização</label>
          <input v-model="laudo.dataFim" type="datetime-local" />
        </div>
      </div>
    </section>

    <!-- AVALIAÇÃO -->
    <section v-if="abaAtiva === 'avaliacao'" class="card-section">
      <div class="avaliacao-topo">
        <div class="form-item grupo-select">
          <label>Grupo de Avaliação</label>
          <select v-model="grupoSelecionadoCodigo">
            <option
              v-for="grupo in gruposExibicao"
              :key="grupo.codigo"
              :value="grupo.codigo"
            >
              {{ grupo.codigo }} - {{ grupo.titulo }}
            </option>
          </select>
        </div>

        <div class="navegacao-grupo">
          <button class="btn-outline" @click="grupoAnterior">Anterior</button>
          <span>{{ indiceGrupoAtual + 1 }} de {{ gruposExibicao.length }}</span>
          <button class="btn-outline" @click="proximoGrupo">Próximo</button>
        </div>
      </div>

      <div v-if="grupoAtual" class="grupo-header">
        <h2>{{ grupoAtual.codigo }} - {{ grupoAtual.titulo }}</h2>
        <p v-if="grupoAtual.descricao">{{ grupoAtual.descricao }}</p>
      </div>

      <div v-if="grupoAtual && itensDoGrupoAtual.length" class="item-list">
        <div
          v-for="item in itensDoGrupoAtual"
          :key="item.codigo"
          class="item-card"
        >
          <div class="item-header">
            <div>
              <div class="item-codigo">{{ item.codigo }}</div>
              <div class="item-texto">{{ item.descricao }}</div>
            </div>
          </div>

          <div class="item-resposta">
            <template v-if="item.tipoResposta === 'CCRN'">
              <button
                v-for="opcao in ['C', 'CR', 'NC', 'NA']"
                :key="opcao"
                type="button"
                class="resposta-btn"
                :class="{ active: obterResposta(item.codigo).valor === opcao }"
                @click="marcarResposta(item.codigo, opcao)"
              >
                {{ opcao }}
              </button>
            </template>

            <template v-else-if="item.tipoResposta === 'SN'">
              <button
                v-for="opcao in ['SIM', 'NAO']"
                :key="opcao"
                type="button"
                class="resposta-btn"
                :class="{ active: obterResposta(item.codigo).valor === opcao }"
                @click="marcarResposta(item.codigo, opcao)"
              >
                {{ opcao }}
              </button>
            </template>
          </div>

          <div class="form-item">
            <label>Observação do Item</label>
            <textarea
              rows="2"
              v-model="obterResposta(item.codigo).observacao"
            ></textarea>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">
        Nenhum item configurado para este grupo.
      </div>
    </section>

    <!-- FECHAMENTO -->
    <section v-if="abaAtiva === 'fechamento'" class="card-section">
      <h2>Fechamento do Laudo</h2>

      <div class="resumo-grid">
        <div class="resumo-card">
          <span>Total Itens</span>
          <strong>{{ resumo.totalItens }}</strong>
        </div>
        <div class="resumo-card">
          <span>Conformes (C)</span>
          <strong>{{ resumo.totalC }}</strong>
        </div>
        <div class="resumo-card">
          <span>Conforme c/ Restrição (CR)</span>
          <strong>{{ resumo.totalCR }}</strong>
        </div>
        <div class="resumo-card">
          <span>Não Conforme (NC)</span>
          <strong>{{ resumo.totalNC }}</strong>
        </div>
        <div class="resumo-card">
          <span>Não Avaliado (NA)</span>
          <strong>{{ resumo.totalNA }}</strong>
        </div>
        <div class="resumo-card">
          <span>Itens Utilizáveis</span>
          <strong>{{ resumo.totalUtilizaveis }}</strong>
        </div>
        <div class="resumo-card">
          <span>% Conformidade</span>
          <strong>{{ resumo.percentualFormatado }}</strong>
        </div>
        <div class="resumo-card destaque">
          <span>Classificação</span>
          <strong>{{ resumo.grupoClassificacao }}</strong>
        </div>
      </div>

      <div class="form-grid">
        <div class="form-item col-2">
          <label>Observações e Sugestões</label>
          <textarea rows="6" v-model="laudo.observacoes"></textarea>
        </div>

        <div class="form-item col-2">
          <label>Disposição</label>
          <textarea rows="6" v-model="laudo.disposicao"></textarea>
        </div>

        <div class="form-item">
          <label>Responsável / Carimbo - Supervisor(a)</label>
          <input v-model="laudo.nomeSupervisorAssinatura" type="text" />
        </div>

        <div class="form-item">
          <label>Responsável pela Empresa</label>
          <input v-model="laudo.nomeResponsavelEmpresa" type="text" />
        </div>

        <div class="form-item">
          <label>Testemunha</label>
          <input v-model="laudo.nomeTestemunha" type="text" />
        </div>
      </div>

      <div class="closing-actions">
        <button class="btn-primary" @click="gerarRelatorio">
          Atualizar Relatório Base
        </button>
        <button class="btn-outline" @click="imprimirRelatorio">
          Imprimir Relatório
        </button>
      </div>
    </section>

    <!-- RELATÓRIO -->
    <section v-if="mostrarRelatorio" class="card-section report-section">
      <div class="report-actions">
        <h2>Relatório Base Gerado</h2>
        <button class="btn-outline" @click="imprimirRelatorio">Imprimir</button>
      </div>

      <div id="relatorio-supervisao" class="report-preview">
        <div class="report-head">
          <h1>{{ modelo.descricao }}</h1>
          <p>Inspeção de Integração ao SISBI-POA</p>
          <p><strong>Nº:</strong> {{ laudo.numeroLaudo || '-' }}</p>
        </div>

        <div class="report-block">
          <h3>1. Identificação do Estabelecimento</h3>
          <div class="report-grid">
            <div><strong>Razão Social:</strong> {{ laudo.razaoSocial || '-' }}</div>
            <div><strong>Nome Fantasia:</strong> {{ laudo.nomeFantasia || '-' }}</div>
            <div><strong>Registro SIM:</strong> {{ laudo.numeroRegistroSim || '-' }}</div>
            <div><strong>CNPJ/CPF:</strong> {{ laudo.cnpjCpf || '-' }}</div>
            <div><strong>Município:</strong> {{ laudo.municipio || '-' }}</div>
            <div><strong>Data da Inspeção:</strong> {{ formatarData(laudo.dataInspecao) }}</div>
            <div><strong>Atividade:</strong> {{ laudo.atividade || '-' }}</div>
            <div><strong>Classificação:</strong> {{ laudo.classificacaoEstabelecimento || '-' }}</div>
          </div>
        </div>

        <div class="report-block">
          <h3>2. Dados da Supervisão</h3>
          <div class="report-grid">
            <div><strong>Tipo:</strong> {{ laudo.tipoSupervisao || '-' }}</div>
            <div><strong>Fiscal do Estabelecimento:</strong> {{ laudo.fiscalEstabelecimento || '-' }}</div>
            <div><strong>Fiscal da Supervisão:</strong> {{ laudo.fiscalSupervisao || '-' }}</div>
            <div><strong>Início:</strong> {{ formatarDataHora(laudo.dataInicio) }}</div>
            <div><strong>Finalização:</strong> {{ formatarDataHora(laudo.dataFim) }}</div>
          </div>
        </div>

        <div class="report-block">
          <h3>3. Resumo Sanitário</h3>
          <table class="report-table">
            <thead>
              <tr>
                <th>Total</th>
                <th>C</th>
                <th>CR</th>
                <th>NC</th>
                <th>NA</th>
                <th>Utilizáveis</th>
                <th>% Conformidade</th>
                <th>Classificação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ resumo.totalItens }}</td>
                <td>{{ resumo.totalC }}</td>
                <td>{{ resumo.totalCR }}</td>
                <td>{{ resumo.totalNC }}</td>
                <td>{{ resumo.totalNA }}</td>
                <td>{{ resumo.totalUtilizaveis }}</td>
                <td>{{ resumo.percentualFormatado }}</td>
                <td>{{ resumo.grupoClassificacao }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="report-block">
          <h3>4. Itens com Não Conformidade / Restrição</h3>
          <table class="report-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Resposta</th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itensCriticosRelatorio" :key="item.codigo">
                <td>{{ item.codigo }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.valor }}</td>
                <td>{{ item.observacao || '-' }}</td>
              </tr>
              <tr v-if="!itensCriticosRelatorio.length">
                <td colspan="4">Nenhum item crítico registrado.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="report-block">
          <h3>5. Análise Documental</h3>
          <table class="report-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Resposta</th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itensDocumentaisRelatorio" :key="item.codigo">
                <td>{{ item.codigo }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.valor || '-' }}</td>
                <td>{{ item.observacao || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="report-block">
          <h3>6. Observações e Disposição</h3>
          <p><strong>Observações:</strong> {{ laudo.observacoes || '-' }}</p>
          <p><strong>Disposição:</strong> {{ laudo.disposicao || '-' }}</p>
        </div>

        <div class="report-signatures">
          <div class="signature-box">
            <span>Supervisor(a)</span>
            <strong>{{ laudo.nomeSupervisorAssinatura || '____________________________' }}</strong>
          </div>

          <div class="signature-box">
            <span>Responsável pela Empresa</span>
            <strong>{{ laudo.nomeResponsavelEmpresa || '____________________________' }}</strong>
          </div>

          <div class="signature-box">
            <span>Testemunha</span>
            <strong>{{ laudo.nomeTestemunha || '____________________________' }}</strong>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { computed, reactive, ref } from 'vue';

export default {
  name: 'SupervisaoSisbiPoc',
  setup() {
    const abaAtiva = ref('cabecalho');
    const mostrarRelatorio = ref(false);

    const modelo = reactive({
      codigo: 'PLA03',
      descricao: 'PLA 03 - Laudo de Supervisão 2025',
      versao: '2.0',
    });

    const laudo = reactive({
      numeroLaudo: 'SIM 018/ARARANGUÁ/2026',
      dataInspecao: '',
      tipoSupervisao: 'SUPERVISAO ANUAL',
      tipoSupervisaoOutros: '',

      razaoSocial: 'Frigorífico Modelo Ltda',
      nomeFantasia: 'Frigorífico Modelo',
      numeroRegistroSim: '018/SIM',
      inscricaoEstadual: '',
      cnpjCpf: '',
      endereco: '',
      bairro: '',
      municipio: 'Araranguá',
      cep: '',
      uf: 'SC',
      telefone: '',
      email: '',
      atividade: 'Industrialização de produtos cárneos',
      classificacaoEstabelecimento: 'Entreposto / Unidade Industrial',

      possuiResponsavelTecnico: 'S',
      nomeResponsavelTecnico: '',
      formacaoAcademica: '',
      numeroPessoas: 0,
      numeroTurnos: 1,

      nomeAcompanhante: '',
      cpfAcompanhante: '',
      funcaoAcompanhante: '',

      fiscalEstabelecimento: '',
      fiscalSupervisao: '',
      dataInicio: '',
      dataFim: '',

      observacoes: '',
      disposicao: 'Prazo de 15 (quinze) dias para apresentar relatório de ações corretivas.',
      nomeSupervisorAssinatura: '',
      nomeResponsavelEmpresa: '',
      nomeTestemunha: '',
    });

    const grupos = ref([
      {
        codigo: '1.1',
        titulo: 'ÁREA EXTERNA',
        descricao: 'Avaliação do estabelecimento in loco',
        tipoResposta: 'CCRN',
        itens: [
          {
            codigo: '1.1.1',
            descricao: 'Área externa livre de focos de insalubridade, de objetos em desuso ou estranhos ao ambiente, de vetores e outros animais no pátio e vizinhança; de focos de poeira; de acúmulo de lixo nas imediações, de água estagnada, dentre outros.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
          {
            codigo: '1.1.2',
            descricao: 'Vias de acesso interno com superfície dura ou pavimentada, adequada ao trânsito sobre rodas.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
          {
            codigo: '1.1.3',
            descricao: 'Vias de acesso à área industrial apresentam escoamento adequado e limpas.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
        ],
      },
      {
        codigo: '1.2',
        titulo: 'ÁREA INTERNA',
        descricao: 'Avaliação do estabelecimento in loco',
        tipoResposta: 'CCRN',
        itens: [
          {
            codigo: '1.2.1',
            descricao: 'Área interna livre de objetos em desuso ou estranhos ao ambiente.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
        ],
      },
      {
        codigo: '1.3.1',
        titulo: 'PISOS',
        descricao: 'Instalações industriais',
        tipoResposta: 'CCRN',
        itens: [
          {
            codigo: '1.3.1.1',
            descricao: 'Material que permite fácil e apropriada higienização.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
          {
            codigo: '1.3.1.2',
            descricao: 'Em adequado estado de conservação.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
        ],
      },
      {
        codigo: '5.2',
        titulo: 'PROGRAMAS DE AUTOCONTROLE',
        descricao: 'Avaliação documental / operacional',
        tipoResposta: 'CCRN',
        itens: [
          {
            codigo: '5.2.1',
            descricao: 'Existência da descrição do PAC de manutenção das instalações e equipamentos.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
          {
            codigo: '5.2.2',
            descricao: 'O PAC descrito está sendo cumprido.',
            tipoResposta: 'CCRN',
            geraPercentual: true,
          },
        ],
      },
      {
        codigo: '6.1',
        titulo: 'ANÁLISE DOCUMENTAL',
        descricao: 'Análise documental do CIM-AMREC',
        tipoResposta: 'SN',
        itens: [
          {
            codigo: '6.1.1',
            descricao: 'A frequência de vistorias foi respeitada e suficiente.',
            tipoResposta: 'SN',
            geraPercentual: false,
          },
          {
            codigo: '6.1.2',
            descricao: 'Houve registro de todo o procedimento de vistoria oficial – descrição das não conformidades (NC), relatório de ação corretiva (RAC).',
            tipoResposta: 'SN',
            geraPercentual: false,
          },
          {
            codigo: '6.1.3',
            descricao: 'Os registros estão completos e condizentes com o encontrado na vistoria de supervisão.',
            tipoResposta: 'SN',
            geraPercentual: false,
          },
        ],
      },
    ]);

    const respostas = reactive({});

    const grupoSelecionadoCodigo = ref(grupos.value[0]?.codigo || '');

    const gruposExibicao = computed(() => grupos.value);

    const indiceGrupoAtual = computed(() => {
      return gruposExibicao.value.findIndex(g => g.codigo === grupoSelecionadoCodigo.value);
    });

    const grupoAtual = computed(() => {
      return gruposExibicao.value.find(g => g.codigo === grupoSelecionadoCodigo.value) || null;
    });

    const itensDoGrupoAtual = computed(() => {
      return grupoAtual.value?.itens || [];
    });

    function obterResposta(codigo) {
      if (!respostas[codigo]) {
        respostas[codigo] = {
          valor: '',
          observacao: '',
        };
      }
      return respostas[codigo];
    }

    function marcarResposta(codigo, valor) {
      obterResposta(codigo).valor = valor;
    }

    function grupoAnterior() {
      const idx = indiceGrupoAtual.value;
      if (idx > 0) {
        grupoSelecionadoCodigo.value = gruposExibicao.value[idx - 1].codigo;
      }
    }

    function proximoGrupo() {
      const idx = indiceGrupoAtual.value;
      if (idx < gruposExibicao.value.length - 1) {
        grupoSelecionadoCodigo.value = gruposExibicao.value[idx + 1].codigo;
      }
    }

    const itensPontuaveis = computed(() => {
      return grupos.value.flatMap(grupo =>
        grupo.itens.filter(item => item.geraPercentual)
      );
    });

    const resumo = computed(() => {
      let totalItens = 0;
      let totalC = 0;
      let totalCR = 0;
      let totalNC = 0;
      let totalNA = 0;

      itensPontuaveis.value.forEach(item => {
        totalItens++;
        const valor = obterResposta(item.codigo).valor;

        if (valor === 'C') totalC++;
        else if (valor === 'CR') totalCR++;
        else if (valor === 'NC') totalNC++;
        else if (valor === 'NA') totalNA++;
      });

      const totalUtilizaveis = totalItens - totalNA;
      const percentual = totalUtilizaveis > 0
        ? (totalC / totalUtilizaveis) * 100
        : 0;

      let grupoClassificacao = 'GRUPO 03';
      if (percentual >= 85) grupoClassificacao = 'GRUPO 01';
      else if (percentual >= 61) grupoClassificacao = 'GRUPO 02';

      return {
        totalItens,
        totalC,
        totalCR,
        totalNC,
        totalNA,
        totalUtilizaveis,
        percentual,
        percentualFormatado: `${percentual.toFixed(2)}%`,
        grupoClassificacao,
      };
    });

    const itensCriticosRelatorio = computed(() => {
      return grupos.value
        .flatMap(grupo => grupo.itens)
        .map(item => ({
          codigo: item.codigo,
          descricao: item.descricao,
          valor: obterResposta(item.codigo).valor,
          observacao: obterResposta(item.codigo).observacao,
          tipoResposta: item.tipoResposta,
        }))
        .filter(item => ['CR', 'NC'].includes(item.valor));
    });

    const itensDocumentaisRelatorio = computed(() => {
      return grupos.value
        .flatMap(grupo => grupo.itens)
        .filter(item => item.tipoResposta === 'SN')
        .map(item => ({
          codigo: item.codigo,
          descricao: item.descricao,
          valor: obterResposta(item.codigo).valor,
          observacao: obterResposta(item.codigo).observacao,
        }));
    });

    function gerarRelatorio() {
      mostrarRelatorio.value = true;
      abaAtiva.value = 'fechamento';
    }

    function imprimirRelatorio() {
      mostrarRelatorio.value = true;

      setTimeout(() => {
        const conteudo = document.getElementById('relatorio-supervisao');
        if (!conteudo) return;

        const janela = window.open('', '_blank', 'width=1100,height=800');
        if (!janela) return;

        janela.document.write(`
          <html>
            <head>
              <title>Relatório de Supervisão</title>
              <style>
                body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
                h1, h2, h3 { margin-bottom: 8px; }
                .report-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px 20px; margin-bottom: 12px; }
                .report-block { margin-bottom: 20px; }
                .report-table { width: 100%; border-collapse: collapse; margin-top: 8px; }
                .report-table th, .report-table td { border: 1px solid #ccc; padding: 8px; text-align: left; vertical-align: top; }
                .report-signatures { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 40px; }
                .signature-box { text-align: center; padding-top: 30px; }
                .signature-box strong { display: block; border-top: 1px solid #666; padding-top: 8px; }
              </style>
            </head>
            <body>${conteudo.innerHTML}</body>
          </html>
        `);

        janela.document.close();
        janela.focus();
        janela.print();
      }, 150);
    }

    function formatarData(data) {
      if (!data) return '-';
      const partes = data.split('-');
      if (partes.length !== 3) return data;
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    function formatarDataHora(valor) {
      if (!valor) return '-';
      const [data, hora] = valor.split('T');
      return `${formatarData(data)} ${hora || ''}`.trim();
    }

    return {
      abaAtiva,
      modelo,
      laudo,
      gruposExibicao,
      grupoSelecionadoCodigo,
      grupoAtual,
      indiceGrupoAtual,
      itensDoGrupoAtual,
      obterResposta,
      marcarResposta,
      grupoAnterior,
      proximoGrupo,
      resumo,
      mostrarRelatorio,
      gerarRelatorio,
      imprimirRelatorio,
      itensCriticosRelatorio,
      itensDocumentaisRelatorio,
      formatarData,
      formatarDataHora,
    };
  },
};
</script>

<style scoped>
.supervisao-page {
  padding: 20px;
  background: #f6f8fb;
  min-height: 100%;
  color: #1f2937;
}

.page-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.page-header h1 {
  margin: 0;
  font-size: 26px;
}

.page-header p {
  margin: 4px 0 0;
  color: #6b7280;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.status-bar {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.status-card,
.resumo-card,
.card-section,
.item-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.status-card {
  padding: 12px;
}

.status-label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.card-section {
  padding: 18px;
  margin-bottom: 18px;
}

.card-section h2,
.card-section h3 {
  margin-top: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-item label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.form-item input,
.form-item select,
.form-item textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
}

.col-2 {
  grid-column: span 2;
}

.avaliacao-topo {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: end;
  margin-bottom: 16px;
}

.grupo-select {
  min-width: 380px;
}

.navegacao-grupo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.grupo-header {
  margin-bottom: 16px;
  padding: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.item-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item-card {
  padding: 16px;
}

.item-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.item-codigo {
  font-size: 13px;
  font-weight: 700;
  color: #1d4ed8;
  margin-bottom: 6px;
}

.item-texto {
  line-height: 1.45;
}

.item-resposta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.resposta-btn,
.btn-outline,
.btn-primary {
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.resposta-btn,
.btn-outline {
  background: #fff;
  border: 1px solid #cbd5e1;
  color: #1f2937;
}

.resposta-btn.active {
  background: #dbeafe;
  border-color: #60a5fa;
  color: #1d4ed8;
  font-weight: 700;
}

.btn-primary {
  background: #2563eb;
  border: 1px solid #2563eb;
  color: #fff;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-outline:hover {
  background: #f3f4f6;
}

.resumo-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.resumo-card {
  padding: 14px;
}

.resumo-card span {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}

.resumo-card strong {
  font-size: 20px;
}

.resumo-card.destaque {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.closing-actions,
.report-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 14px;
}

.report-preview {
  background: #fff;
  padding: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.report-head {
  text-align: center;
  margin-bottom: 24px;
}

.report-head h1 {
  margin-bottom: 8px;
}

.report-block {
  margin-bottom: 22px;
}

.report-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 10px 20px;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
}

.report-table th,
.report-table td {
  border: 1px solid #d1d5db;
  padding: 10px;
  text-align: left;
  vertical-align: top;
  font-size: 13px;
}

.report-signatures {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

.signature-box {
  text-align: center;
}

.signature-box span {
  display: block;
  margin-bottom: 30px;
  color: #6b7280;
  font-size: 13px;
}

.signature-box strong {
  display: block;
  border-top: 1px solid #9ca3af;
  padding-top: 8px;
}

.empty-state {
  padding: 30px;
  text-align: center;
  color: #6b7280;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

@media (max-width: 1100px) {
  .status-bar,
  .resumo-grid,
  .form-grid,
  .report-grid,
  .report-signatures {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }

  .page-header,
  .avaliacao-topo {
    flex-direction: column;
    align-items: stretch;
  }

  .grupo-select {
    min-width: auto;
  }
}

@media (max-width: 700px) {
  .status-bar,
  .resumo-grid,
  .form-grid,
  .report-grid,
  .report-signatures {
    grid-template-columns: 1fr;
  }

  .col-2 {
    grid-column: span 1;
  }
}
</style>